import React, { useState, useEffect } from "react";
import { Card,Container,Row,Col } from 'react-bootstrap';  
import { Link, useNavigate  } from 'react-router-dom';  

/** Font Awesome icons (React)  */
import { FaChevronRight,FaExclamationTriangle } from "react-icons/fa";
import { MdArrowBack } from "react-icons/md";

/** Custom Styles */
import '../css/styles.css';  

/** Custom Components */
import NavbarComponent from '../navbar';
import FooterComponent from '../footer';

import { REVISED_DEMANDS_FOR_GRANTS_URL,DOWNLOAD_URL } from '../utils/constants';
 
const RevisedDemandComponent = () => {
	let navigate = useNavigate();

	const [hasError, setErrors] = useState(false);
	const [items, setItems] = useState([]);
	const [isLoaded, setLoader ] = useState(false);
	const requestOptions = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({ fin_year: localStorage.getItem('fin_year') })
	};
	const fetchData = async () => {
		if(localStorage.getItem('fin_year') == null){
			alert("Select Financial Year")
			navigate("/main");
			return false;
		}
		const res = await fetch(REVISED_DEMANDS_FOR_GRANTS_URL,requestOptions);
		res
			.json()
			.then(res => {
				setItems(res.DATA)
			})
			.catch(err => setErrors(err));
	};

	useEffect(() => {
		fetchData();
		setLoader(true);
	},[]); 

	if(isLoaded === true){
		return (
			<div>
				<NavbarComponent/>
				<nav className="sticky">
					<Row>
						<Col className="col-4 offset-1">
							<Link to="/main" title="Back to main page">
								<h6 className="logout-icon">
									<MdArrowBack/>
									<span className='link'>Back to main</span>
								</h6>
							</Link>
						</Col>
					</Row>
				</nav>
				<div className="App-common main"> 
					<Container>
						<Row>
							{items.map(item => 
								(item.haschild === "N")?
									(<Col className="col-xs-12 col-sm-6 col-md-4 col-lg-3 mt-1" key={item.id}>
										{(item.demand_no === '0')?
											(<a href={`${DOWNLOAD_URL}/${item.link}/DemandsForGrants`}>
												<Card border="secondary" className='custom-card'>
													<Card.Body>
														<Card.Title>
															<Row>
																<Col>
																	<b>{item.description} - <em>(Complete Document)</em></b>
																</Col>
																<Col className="col-1">
																	<span className="iconStyle">
																		<img src="../images/pdf-icon.png" alt="pdf" width="20"/>
																	</span>
																</Col>
															</Row>
														</Card.Title>
													</Card.Body>
												</Card>
											</a>)
										:(<Link to={`/view/${item.link}`}>
											<Card border="secondary" className='custom-card'>
												<Card.Body>
													<Card.Title>
														<Row>
															<Col>
																{item.demand_no} - {item.description}
															</Col>
															<Col className="col-1">
																<span className="iconStyle">
																	<img src="../images/pdf-icon.png" alt="pdf" width="20"/>
																</span>
															</Col>
														</Row>
													</Card.Title>
												</Card.Body>
											</Card>
										</Link>)}
									</Col>)
									:(<Col className="col-xs-12 col-sm-6 col-md-4 col-lg-3 mt-1" key={item.id}>
										<Link to={`/demand/${item.demand_no}`} >
											<Card border="secondary" className='custom-card'>
												<Card.Body>
													<Card.Title>
														<Row>
															<Col>
																{item.demand_no} - {item.description}													
															</Col>
															<Col className="col-1">
																<span className="iconStyle"><FaChevronRight/></span>
															</Col>
														</Row>
													</Card.Title>
												</Card.Body>
											</Card>						
										</Link>
									</Col>
									)
								)
							}	
						</Row>
					</Container> 
				</div>
				<FooterComponent/>			
			</div>
		)
	}
	else if(hasError === true){
		return (<div>
			<NavbarComponent/>
			<div className="App-common main">
				<Container className="centered">
					<Row>
						<Col className="col-1"></Col>
						<Col>Error <FaExclamationTriangle/> <h6>{hasError}.<br/>
						Refresh page to retry.</h6></Col>
					</Row>
				</Container>
			</div>
			<FooterComponent/>
		</div>)
	}
	else if(items == null){
		return (<div>
			<NavbarComponent/>
			<div className="App-common main">
				<Container className="centered">
					<Row>
						<Col className="col-1"></Col>
						<Col><FaExclamationTriangle/> 
							<h6>No data available.<br/>
								Click <Link to="/main">here</Link> to go back.
							</h6>
						</Col>
					</Row>
				</Container>
			</div>
			<FooterComponent/>
		</div>)
	}
	else{
		return(<div class="simple-shape two"></div>)
	} 
}  
	  
export default RevisedDemandComponent; 
